module.exports = __webpack_public_path__ + "assets/sentiment_positive.8d1fd57a.svg";